import generate_uuid from './generate_uuid'
export default generate_uuid
